<ion-header>
  <ion-toolbar color="primary">
    <ion-title i18n>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" />
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  @if (subtitle) {
    <ion-toolbar *ngIf="subtitle">
      <ion-title>{{ subtitle }}</ion-title>
    </ion-toolbar>
  }
</ion-header>

<ion-content>
  <ion-item class="no-border">
    <ion-label i18n>Sélectionner tout</ion-label>
    <ion-checkbox slot="end" color="primary" [ngModel]="isAllSelected()" (ionChange)="selectAll($event)" />
  </ion-item>
  @if (displaySubs()) {
    <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: deepFilterValues() }" />
  } @else {
    @for (filterValue of deepFilterValues(); track filterValue.label) {
      <ion-item lines="none">
        <ion-checkbox
          class="checkbox-acc"
          slot="start"
          color="primary"
          justify="start"
          labelPlacement="end"
          (ionChange)="onFilterChanged(filterValue, $event)"
          [ngModel]="filterValue.checked"
        >
          {{ filterValue.label }}
        </ion-checkbox>
      </ion-item>
    }
  }
</ion-content>
<ion-footer class="ion-no-border">
  <ion-button expand="block" color="danger" (click)="applyFilter()">{{ textButton }}</ion-button>
</ion-footer>

<ng-template #recursiveList let-items>
  <ion-accordion-group [multiple]="true">
    @for (item of items; track item) {
      @if (item.subValues?.length > 0 && item.prop.includes('descriptionHierar')) {
        <ion-accordion toggleIconSlot="start" toggleIcon="iot-chevron-right">
          <ion-item slot="header" lines="none">
            <ion-checkbox
              class="checkbox-acc"
              (click)="$event.stopPropagation()"
              [indeterminate]="item.selectState === 'semi'"
              color="primary"
              justify="start"
              labelPlacement="end"
              [ngModel]="item.checked"
              (ionChange)="onFilterChanged(item, $event)"
            >
              <div class="checbox-container">
                @if (item.prop.includes('descriptionHierar')) {
                  <ion-icon name="folder" color="medium" />
                }
                @if (item.prop === 'descriptionMetier') {
                  <ion-icon name="folder-outline" color="medium" />
                }
                <crt-text-truncated [text]="item.label" [crop]="10" />
              </div>
            </ion-checkbox>
          </ion-item>
          <div class="sub" slot="content">
            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item.subValues }" />
          </div>
        </ion-accordion>
      } @else {
        <ion-item class="item-no-acc" lines="none">
          <ion-checkbox
            slot="start"
            color="primary"
            justify="start"
            [indeterminate]="item.selectState === 'semi'"
            labelPlacement="end"
            (ionChange)="onFilterChanged(item, $event)"
            [ngModel]="item.checked"
          >
            <div class="checbox-container">
              @if (item.prop.includes('descriptionHierar')) {
                <ion-icon name="folder" color="medium" />
              }
              @if (item.prop === 'descriptionMetier') {
                <ion-icon name="folder-outline" color="medium" />
              }
              <crt-text-truncated [text]="item.label" [crop]="10" />
            </div>
          </ion-checkbox>
        </ion-item>
      }
    }
  </ion-accordion-group>
</ng-template>
